import DataModule from "@/components/DataModule";
import { MODULES } from "@/config/modules";
import DefectLeaderboard from "@/components/DefectLeaderboard";
import { useTenant } from "@/context/TenantContext";

export default function People() {
  const { company } = useTenant();
  const cur = company?.currency || "EUR";
  return (
    <div className="space-y-6">
      <DefectLeaderboard currency={cur} />
      <DataModule module={MODULES.employees} currency={cur} />
    </div>
  );
}
